import { Components, Theme } from '@mui/joy';

declare module '@mui/joy/LinearProgress' {
  interface LinearProgressOwnerState {
    animated: true;
  }
}

export const JoyProgressConfig: Partial<Components<Theme>> = {
  JoyLinearProgress: {
    styleOverrides: {
      root: ({ theme, ownerState }) => {
        return {
          backgroundColor: theme.palette.neutral[200],
          '&.stripes:before': {
            backgroundImage:
              'linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent)',
            backgroundSize: '1rem 1rem',
            animation: '1s linear infinite progress-bar-stripes',
          },
          ...(ownerState.color === 'warning' && {
            color: theme.palette.warning[300],
          }),
        };
      },
    },
    defaultProps: {},
  },
};
